import { queryOptions } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { $api, unwrap } from '~/lib/api-client';

export const versionNumberQueryOptions = () =>
  queryOptions({
    queryKey: ['liftstatus', 'version'],
    queryFn: async () => {
      try {
        const result = await unwrap($api['/liftstatus/version'].GET());

        return result;
      } catch (error) {
        console.error(error);
        toast.error('Error fetching version');

        throw error;
      }
    },
    refetchOnWindowFocus: false,
    retry: false,
  });
